export default "__VITE_ASSET__BfY9wSSU__"